import { combineReducers } from "redux";

import authDrawer from "./authDrawer";
import authors from "../author/reducers/authors";
import upcomingEvents from "../events/reducers/events";
import latestStories from "./latestStories";
import navigation from "./navigation";
import newsletters from "../subscriptions/reducers/newsletters";
import storiesStream from "./storiesStream";
import subscriptions from "../subscriptions/reducers/subscriptions";
import trending from "./trending";
import search from "./search";
import userSettings from "../users/reducers/userSettings";
import user from "./user";

export default combineReducers({
  authDrawer,
  authors,
  upcomingEvents,
  latestStories,
  navigation,
  newsletters,
  search,
  storiesStream,
  subscriptions,
  trending,
  userSettings,
  user,
});
